import { useId, useRef, CSSProperties, ImgHTMLAttributes } from "react";

type ImageLogoProps = {
  width?: number;
  height?: number | "auto";
  src: string;
  fallbackSrc: string;
  alt: string;
  title: string;
  className?: string;
  style?: CSSProperties;
} & Pick<ImgHTMLAttributes<HTMLImageElement>, "loading">;

const ImageLogo = ({
  width,
  height = "auto",
  src,
  fallbackSrc,
  alt,
  title,
  className,
  style,
  loading = "lazy",
}: ImageLogoProps) => {
  const reactId = useId();
  const imgRef = useRef<HTMLImageElement>(null);
  const resolvedHeight = height === "auto" ? undefined : height;

  const handleImageError = () => {
    const img = imgRef.current;
    if (!img || img.dataset.fallbackApplied === "true") return;
    img.dataset.fallbackApplied = "true";
    img.src = fallbackSrc;
  };

  return (
    <img
      ref={imgRef}
      id={`image-logo-${reactId}`}
      width={width}
      height={resolvedHeight}
      src={src}
      alt={alt}
      title={title}
      loading={loading}
      className={className}
      style={{
        width,
        height: resolvedHeight ?? "auto",
        maxWidth: "100%",
        display: "block",
        ...style,
      }}
      onError={handleImageError}
    />
  );
};

export default ImageLogo;
